export default {
  title: '申请状态自动变更管理',
  menu: '申请状态自动变更管理',
  label: {
    status: '简历状态',
    statusDwellTime: '状态停留时间',
    autoChangeTo: '自动将状态更改为',
    hasConfig: {
      has: '已配置',
      not: '未配置'
    }
  },
  placeholder: {
    dwellTime: '请输入天数',
    autoChangeTo: '请选择'
  },
  btn: {
    deleteConfig: '删除',
    saveConfig: '保存',
    addConfig: '添加'
  },
  message: {
    deleteSuccess: '删除成功',
    cannotSaveEmpty: '请至少配置一条规则',
    dwellTimeIsNotInt: '请输入一个大于0的整数',
    remindConfigRuleTip: '固定锁定时间为5天时，需要在第二天、第四天以及第五天提醒的话，需要配置为：2+2+1\n永久锁定时，需要每5天提醒一次，则配置为：5',
    confirmDelete: '确定删除该配置吗？'
  }
}
